
const LIMIT = 2
export default {
  name: 'AsideVideo',

  data() {
    return {
      posts: [],
      postsCount: 0,
      isLoad: false,
    }
  },

  async fetch() {
    this.isLoad = true
    await this.fetchVideos()
    this.isLoad = false
  },
  methods: {
    async fetchVideos() {
      const { articles, countAllPublishedArticles } = await this.$axios.$get(
        '/videos/popular/month',
        {
          params: {
            limit: LIMIT,
            offset: 0,
          },
        }
      )

      this.posts = articles
      this.postsCount = countAllPublishedArticles
    },
  },
}
